import { AttributeModel } from "../main/dynamic/model/attribute.model"
import { InstanceModel } from "./instance.model"

export class ProcessModel {
    id: string
    policyId: string
    policyName: string
    policyVersionId: string
    attributes: AttributeModel[]
    timeline: AttributeModel[]
    creationDate: string
    versions?: AttributeModel[]
    currentStep?: InstanceModel
    instance?: InstanceModel

    constructor(policyId?: string, versionId?: string) {
        this.policyId = policyId
        this.policyVersionId = versionId
        this.attributes = []
        this.versions = []
    }
}